import * as Types from '../../../gql/base-types';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';

// =============================================================================
// Auto-generated by GraphQL Codegen - DO NOT EDIT
// Change the .gql source (or the schema) and re-run: pnpm codegen
// =============================================================================

const defaultOptions = {} as const;
export type GetCustomersAndMovesQueryVariables = Types.Exact<{
  start: Types.Scalars['timestamptz']['input'];
  end: Types.Scalars['timestamptz']['input'];
}>;


export type GetCustomersAndMovesQuery = { __typename?: 'query_root', customers: Array<{ __typename?: 'customers', id: number, name?: string | null, moves: Array<{ __typename?: 'moves', id: number, active: number, status?: string | null, cancel_status?: string | null, vehicle_color?: string | null, vehicle_make?: string | null, vehicle_model?: string | null, vehicle_stock?: string | null, vehicle_vin?: string | null, vehicle_year?: string | null, ready_by?: string | null, pickup_time?: string | null, delivery_time?: string | null, pickup_started?: string | null, pickup_arrived?: string | null, pickup_successful?: string | null, delivery_started?: string | null, delivery_arrived?: string | null, delivery_successful?: string | null, consumer_type?: string | null, consumer_name?: string | null, consumer_phone?: string | null, lite: boolean, lane?: { __typename?: 'lanes', duration_sec?: number | null, pickup: { __typename?: 'locations', name?: string | null }, delivery: { __typename?: 'locations', name?: string | null } } | null }> }> };


export const GetCustomersAndMovesDocument = gql`
    query getCustomersAndMoves($start: timestamptz!, $end: timestamptz!) {
  customers(order_by: {name: asc}) {
    id
    name
    moves(
      where: {active: {_eq: 1}, move_type: {_ilike: "drive"}, _or: [{consumer_type: {_is_null: true}}, {consumer_type: {_nilike: "loaner"}}], _and: [{ready_by: {_gte: $start}}, {ready_by: {_lte: $end}}]}
      order_by: {ready_by: asc}
    ) {
      id
      active
      status
      cancel_status
      lane {
        duration_sec
        pickup {
          name
        }
        delivery {
          name
        }
      }
      vehicle_color
      vehicle_make
      vehicle_model
      vehicle_stock
      vehicle_vin
      vehicle_year
      ready_by
      pickup_time
      delivery_time
      pickup_started
      pickup_arrived
      pickup_successful
      delivery_started
      delivery_arrived
      delivery_successful
      consumer_type
      consumer_name
      consumer_phone
      lite
    }
  }
}
    `;

/**
 * __useGetCustomersAndMovesQuery__
 *
 * To run a query within a React component, call `useGetCustomersAndMovesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCustomersAndMovesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCustomersAndMovesQuery({
 *   variables: {
 *      start: // value for 'start'
 *      end: // value for 'end'
 *   },
 * });
 */
export function useGetCustomersAndMovesQuery(baseOptions: Apollo.QueryHookOptions<GetCustomersAndMovesQuery, GetCustomersAndMovesQueryVariables> & ({ variables: GetCustomersAndMovesQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCustomersAndMovesQuery, GetCustomersAndMovesQueryVariables>(GetCustomersAndMovesDocument, options);
      }
export function useGetCustomersAndMovesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCustomersAndMovesQuery, GetCustomersAndMovesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCustomersAndMovesQuery, GetCustomersAndMovesQueryVariables>(GetCustomersAndMovesDocument, options);
        }
// @ts-ignore
export function useGetCustomersAndMovesSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetCustomersAndMovesQuery, GetCustomersAndMovesQueryVariables>): Apollo.UseSuspenseQueryResult<GetCustomersAndMovesQuery, GetCustomersAndMovesQueryVariables>;
export function useGetCustomersAndMovesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetCustomersAndMovesQuery, GetCustomersAndMovesQueryVariables>): Apollo.UseSuspenseQueryResult<GetCustomersAndMovesQuery | undefined, GetCustomersAndMovesQueryVariables>;
export function useGetCustomersAndMovesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetCustomersAndMovesQuery, GetCustomersAndMovesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetCustomersAndMovesQuery, GetCustomersAndMovesQueryVariables>(GetCustomersAndMovesDocument, options);
        }
export type GetCustomersAndMovesQueryHookResult = ReturnType<typeof useGetCustomersAndMovesQuery>;
export type GetCustomersAndMovesLazyQueryHookResult = ReturnType<typeof useGetCustomersAndMovesLazyQuery>;
export type GetCustomersAndMovesSuspenseQueryHookResult = ReturnType<typeof useGetCustomersAndMovesSuspenseQuery>;
export type GetCustomersAndMovesQueryResult = Apollo.QueryResult<GetCustomersAndMovesQuery, GetCustomersAndMovesQueryVariables>;
import { resolveExecutor, type GqlExecutor, type GqlRequestOptions } from '@hopdrive/sdk-core'


/**
 * @source {@link src/features/rooftops/queries/getCustomersAndMoves.query.gql}
 */
export async function getCustomersAndMoves(
  variables: GetCustomersAndMovesQueryVariables,
  options?: { executor?: GqlExecutor; raw?: false } & GqlRequestOptions
): Promise<GetCustomersAndMovesQuery['customers']>
export async function getCustomersAndMoves(
  variables: GetCustomersAndMovesQueryVariables,
  options?: { executor?: GqlExecutor; raw: true } & GqlRequestOptions
): Promise<GetCustomersAndMovesQuery>
export async function getCustomersAndMoves(
  variables: GetCustomersAndMovesQueryVariables,
  options?: { executor?: GqlExecutor; raw?: boolean } & GqlRequestOptions
): Promise<GetCustomersAndMovesQuery['customers'] | GetCustomersAndMovesQuery> {
  const { executor, raw, ...requestOptions } = options ?? {}
  const result = await resolveExecutor(executor).query<GetCustomersAndMovesQuery>(
    GetCustomersAndMovesDocument,
    variables,
    requestOptions
  )
  if (raw) return result
  return result.customers
}